import {NavLink} from 'react-router-dom';
import {Box, Breadcrumbs} from '@mantine/core';

import {Invoice} from '../types';
import {moduleConfig} from '../config';

export const EditPageNavigation = ({component}: { component: Invoice }) => {

    const breadcrumbs = [
        {title: 'Home', href: '/dashboard'},
        {title: `${moduleConfig.titles.plural}`, href: `/invoices`},
        {title: component.id},
    ].map((item, index) => (
        <Box key={index}>
            {item.href ? <NavLink to={item.href}>{item.title}</NavLink> : item.title}
        </Box>
    ));

    return (
        <Box p={'xs'}><Breadcrumbs separator='→' mt='xs'>{breadcrumbs}</Breadcrumbs></Box>
    );
};
